export default "__VITE_ASSET__CaRwC_Jt__"